import "react";
import { transparentize as n } from "polished";
import e from "prop-types";
import { css as o, cx as r } from "@leafygreen-ui/emotion";
import { palette as t, uiColors as a } from "@leafygreen-ui/palette";
import i from "@leafygreen-ui/box";
import { fontFamilies as l } from "@leafygreen-ui/tokens";
import { jsx as c } from "@emotion/react";

function p(n, e, o) {
  return e in n ? Object.defineProperty(n, e, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = o, n;
}

function s() {
  return s = Object.assign || function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var o = arguments[e];

      for (var r in o) {
        Object.prototype.hasOwnProperty.call(o, r) && (n[r] = o[r]);
      }
    }

    return n;
  }, s.apply(this, arguments);
}

function d(n, e) {
  if (null == n) return {};

  var o,
      r,
      t = function (n, e) {
    if (null == n) return {};
    var o,
        r,
        t = {},
        a = Object.keys(n);

    for (r = 0; r < a.length; r++) {
      o = a[r], e.indexOf(o) >= 0 || (t[o] = n[o]);
    }

    return t;
  }(n, e);

  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(n);

    for (r = 0; r < a.length; r++) {
      o = a[r], e.indexOf(o) >= 0 || Object.prototype.propertyIsEnumerable.call(n, o) && (t[o] = n[o]);
    }
  }

  return t;
}

function f(n, e) {
  return e || (e = n.slice(0)), Object.freeze(Object.defineProperties(n, {
    raw: {
      value: Object.freeze(e)
    }
  }));
}

var b,
    u,
    x,
    m,
    y,
    h,
    g = ["className", "contentStyle", "darkMode"],
    k = {
  None: "none",
  Clickable: "clickable"
},
    v = "dark",
    O = "light",
    w = "0 4px 10px -4px ".concat(n(.7, t.black)),
    j = "0 4px 20px -4px ".concat(n(.8, t.black)),
    S = "\n  0 0 0 2px ".concat(t.white, ",\n  0 0 0 4px ").concat(t.blue.light1, "\n"),
    C = "0 4px 20px -4px  ".concat(n(.3, "#000")),
    N = "0 2px 12px -2px ".concat(n(.1, "#000")),
    P = "0 0 0 3px ".concat(a.focus),
    z = (p(y = {}, O, {
  containerStyle: o(b || (b = f(["\n      border: 1px solid ", ";\n      box-shadow: ", ";\n      background-color: white;\n      color: ", ";\n      // TODO: Refresh - remove properties from mode logic\n      border-radius: 24px;\n      font-family: ", ";\n      font-size: 13px;\n      line-height: 20px;\n      padding: 24px;\n      min-height: 68px; // 48px + 20px (padding + line-height)\n    "])), t.gray.light2, w, t.gray.dark3, l.default),
  clickableStyle: o(u || (u = f(["\n      cursor: pointer;\n\n      &:focus {\n        outline: none;\n        box-shadow: ", ", ", ";\n      }\n\n      &:hover,\n      &:active {\n        border: 1px solid ", ";\n        box-shadow: ", ";\n\n        &:focus {\n          box-shadow: ", ", ", ";\n        }\n      }\n    "])), S, w, t.gray.light2, j, S, j)
}), p(y, v, {
  containerStyle: o(x || (x = f(["\n      border: 1px solid ", ";\n      box-shadow: ", ";\n      background-color: ", ";\n      color: ", ";\n      // TODO: Refresh - remove properties from dark mode logic\n      border-radius: 7px;\n      font-family: ", ";\n      padding: 16px;\n    "])), a.gray.dark2, C, a.gray.dark2, a.white, l.legacy),
  clickableStyle: o(m || (m = f(["\n      cursor: pointer;\n\n      &:focus {\n        outline: none;\n        box-shadow: ", ", ", ";\n      }\n\n      &:hover {\n        box-shadow: ", ";\n\n        &:focus {\n          box-shadow: ", ", ", ";\n        }\n      }\n    "])), C, P, N, N, P)
}), y),
    T = o(h || (h = f(["\n  position: relative;\n  transition: 150ms ease-in-out;\n  transition-property: border, box-shadow;\n"]))),
    D = function D(n) {
  var e = n.className,
      o = n.contentStyle,
      t = n.darkMode,
      a = void 0 !== t && t,
      l = d(n, g);
  void 0 === o && ("onClick" in l && void 0 !== l.onClick || "href" in l && l.href) && (o = k.Clickable);
  var f = a ? v : O;
  return c(i, s({
    className: r(T, z[f].containerStyle, p({}, z[f].clickableStyle, o === k.Clickable), e)
  }, l));
};

D.displayName = "Card", D.propTypes = {
  className: e.string
};
export { k as ContentStyle, D as default };